<template>
  <section id="sprachenwrap">
    <tile-header heading="Mehrsprachigkeit" icon-id="mehrsprachigkeit" checkbox-item-id="mehrsprachigkeit" />
    <section class="swiper-align">
      <transition name="fade">
        <div class="swiper-overlay" v-if="!this.contentActive"><span class="overlay-message">Machen Sie Ihre Website international, indem Sie mehrere Sprachen anbieten. Ihre Inhalte lassen sich im Back-End ganz einfach und übersichtlich übersetzen.</span></div>
      </transition>
      <section :class="[{active: this.contentActive}, 'contentwrap']">
        <Swiper :maxslides="2">
          <tile checkbox-id="sprachen" heading="Anzahl der Sprachen" input="rangeslider" icon-id="sprachenanzahl" :rangeMin="2" :rangeMax="10" rangeLabel="Sprachen" :contents="sprachenContent" :hints="sprachenHints" :input-disabled="disabledInputs" />
          <tile checkbox-id="bidirektional" heading="Bidirektionaler Text" input="checkbox" icon-id="bidirektoral" :contents="bidirektionalContent" :hints="bidirektionalHints" :input-disabled="disabledInputs" />
        </Swiper>
      </section>
    </section>
    <controller :nextText="btntext" next="/plugins" prev="/templates" />
    <tween-max v-if="false" />
    <inclusive-footer />
    <how-to />
    <made />
  </section>
</template>

<script>
import TweenMax from 'gsap/TweenMax'
import Swiper from '@/components/Swiper.vue'
import TileHeader from '@/components/TileHeader.vue'
import Tile from '@/components/Tile.vue'
import Controller from '@/components/Controller.vue'
import HowTo from '@/components/HowTo.vue'
import InclusiveFooter from '@/components/InclusiveFooter.vue'
import Made from '@/components/Made.vue'
export default {
  name: 'sprachen',
  data: function () {
    return {
      sprachenContent: [
        { sentence: 'Inhalte im CMS intuitiv selbst auf verschiedene Sprachen übersetzen' },
        { sentence: 'Bis zu 10 verschiedene Sprachen auf der Website' }
      ],
      sprachenHints: [
        { sentence: 'Auf jeder Seite können die Sprachversionen (zum Beispiel Deutsch - Englisch) miteinander verglichen werden' }
      ],
      bidirektionalContent: [
        { sentence: 'Technische Unterstützung zusätzlich für Sprachen, die von rechts nach links gelesen werden' }
      ],
      bidirektionalHints: [
        { sentence: 'Sprachen wie Arabisch oder Hebräisch korrekt auf Ihrer Website anzeigen' }
      ]
    }
  },
  components: {
    Swiper,
    TileHeader,
    Tile,
    HowTo,
    TweenMax,
    Controller,
    InclusiveFooter,
    Made
  },
  methods: {
    toggleContent: function () {
      if (this.contentActive === false) { // aus
        this.getItemByID('sprachen').amount = 2
        this.getItemByID('sprachen').status = this.contentActive
        this.getItemByID('bidirektional').status = this.contentActive
        TweenMax.set('.contentwrap', { '-webkit-filter': 'grayscale(1) blur(1.6px)' })
        TweenMax.set('.contentwrap', { 'opacity': '0.15' })
      } else if (this.contentActive === true) { // an
        this.getItemByID('sprachen').status = this.contentActive
        TweenMax.set('.contentwrap', { '-webkit-filter': 'grayscale(0) blur(0)' })
        TweenMax.set('.contentwrap', { 'opacity': '1' })
      }
    },
    getItemByID: function (itemId) {
      return this.$root.getItemByID(itemId)
    }
  },
  mounted: function () {
    this.toggleContent()
  },
  computed: {
    contentActive: function () {
      return this.getItemByID('mehrsprachigkeit').status
    },
    disabledInputs: function () {
      return !this.contentActive
    },
    btntext: function () {
      if (this.contentActive) {
        return 'nächster Schritt'
      } else {
        return 'nächster Schritt'
      }
    }
  },
  watch: {
    contentActive: function () {
      this.toggleContent()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variables.scss";

#sprachenwrap {
  padding-top: 50px;
}

@media (min-height: 420px) {
  #sprachenwrap {
    padding-bottom: 107px;
  }
}
@media (min-height: 520px) {
  #sprachenwrap {
    padding-bottom: 127px;
  }
}
.swiper-align {
  position: relative;
}
.swiper-overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 2;
  .overlay-message {
    font-family: $secondaryFont;
    font-weight: $secondaryFontNormal;
    font-size: 18px;
    text-align: center;
    width: 100%;
    padding: 15px;
    opacity: 0.9;
    margin-bottom: 60px;
  }
}
@media(min-width:767px) {
  #sprachenwrap {
    padding-top:60px;
  }
  .swiper-overlay {
    .overlay-message {
      padding: 15px 40px 15px 40px;
      font-size: 20px;
    }
  }
}
.contentwrap {
  -webkit-backface-visibility: hidden;
  -webkit-perspective: 1000;
  -webkit-transform: translate3d(0,0,0);
  -webkit-transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000;
  transform: translate3d(0,0,0);
  transform: translateZ(0);
  filter: grayscale(1) blur(2px);
  opacity: 0.15;
}
</style>
